import { AppRouteGroup } from '#/routing/classes/AppRouteGroup';

export const salariesRouteGroup = new AppRouteGroup(
  '/nonprofit-salary-explorer',
);

export const salariesSurveyRoute = salariesRouteGroup.route('survey');

export const salariesFaqRoute = salariesRouteGroup.route('faq');

export const salariesLearnMoreRoute = salariesRouteGroup.route('learn-more');

export const salariesExploreRoute = salariesRouteGroup.route('explore', [
  'exploreTmpId',
]);
